import { Grid, Typography } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import * as React from "react";
import { useState } from "react";
import { Button, useRefresh } from "react-admin";
import sendRequest from "../../dataProvider/sendRequest";
import CustomButtonCancel from "../../unit/CustomButtonCancel";
import CustomButtonSubmit from "../../unit/CustomButtonSubmit";
import CustomDialogTitle from "../../unit/CustomDialogTitle";
import HeaderLabelTitle from "../../unit/HeaderLabelTitle";
import useNotify from "../../unit/useNotify";
import DialogApplicationBaseInfo from "../DialogApplicationBaseInfo";
import CustomApplicationDialogTitle from "./CustomApplicationDialogTitle";
export default function CustomHold2DeclinedFormDialog({ ...props }) {
  const { successNotify, errorNotify, infoNotify } = useNotify();
  const { appId, record } = props;
  const [showLoadingBtn, setShowLoadingBtn] = useState(false);
  const [open, setOpen] = useState(false);
  const refresh = useRefresh();
  const [contactInfo, setContactInfo] = useState<{
    sBankName: string;
    sBankContactName: string;
    sBankPhone: string;
    sBankSupport: string;
  } | null>(null);
  const [emailBodyText, setEmailBodyText] = useState("");

  const handleClickOpen = async () => {
    setShowLoadingBtn(true);
    const response = await sendRequest("bank/contactInfo", { id: appId });

    if (response.code != 200) {
      errorNotify("Error loading contact info " + response?.message);
    } else {
      setContactInfo(response);
      if (!response) {
        setEmailBodyText("");
      } else {
        let emailBody =
          "Thank you very much for your application for a " +
          response?.sProductName +
          " from " +
          response?.sBankName +
          ". Unfortunately, we are unable to proceed with your application.   Please see the attached adverse action notice. If you have questions please call " +
          response?.sBankContactName +
          " at " +
          response?.sBankPhone +
          " to discuss this offer or email her at " +
          response?.sBankSupport +
          ". ";
        setEmailBodyText(emailBody);
      }
    }
    setOpen(true);
    setShowLoadingBtn(false);
  };

  const handleClose = () => {
    setOpen(false);
    setShowLoadingBtn(false);
    refresh();
  };

  return (
    <React.Fragment>
      <Button
        id="btn-application-hold-decline"
        label={showLoadingBtn ? "Loading..." : "Decline"}
        variant="contained"
        size="medium"
        color="error"
        disabled={showLoadingBtn}
        sx={{ marginLeft: "10px", width: "120px" }}
        onClick={handleClickOpen}
      />
      <Dialog
        id="dialog-application-hold-decline"
        open={open}
        onClose={handleClose}
        fullWidth={true}
        maxWidth="md"
        PaperProps={{
          component: "form",
          onSubmit: async (event: React.FormEvent<HTMLFormElement>) => {
            event.preventDefault();
            const formData = new FormData(event.currentTarget);
            const formJson = Object.fromEntries((formData as any).entries());
            const notes = formJson.notes;

            const reqUrl = `applications/actions/hold/decline`;
            const response = await sendRequest(reqUrl, {
              id: appId,
              data: formJson,
            });
            if (response && response.code == "200") {
              successNotify("Data saved successfully");
              if (props.cb) {
                props.cb("Decline");
              }
              handleClose();
            } else {
              errorNotify(response?.message || "Data not saved!");
            }
          },
        }}
      >
        <DialogTitle
          sx={{
            borderBottom: "1px solid #e5e5e5",
            mb: 2,
          }}
        >
          <CustomApplicationDialogTitle record={record} subTitle="Decline" />
        </DialogTitle>
        <DialogContent>
          <DialogContentText></DialogContentText>
          <DialogApplicationBaseInfo appId={appId} record={record} />

          <Grid container sx={{ mb: 0, pb: 1 }}>
            <Typography variant="body1">{emailBodyText}</Typography>
          </Grid>
          <Grid container sx={{ mb: 1, pb: 1 }}>
            <Grid sx={{ mb: 0 }} container>
              <HeaderLabelTitle title="Please Copy And Paste ShareFile Link Here" />
            </Grid>
            <Grid sx={{ mb: 0 }} container>
              <TextField
                fullWidth
                type="text"
                variant="outlined"
                id="link"
                name="link"
              />
            </Grid>
          </Grid>
          <Grid container sx={{ mb: 0, pb: 1 }}>
            <Grid sx={{ mb: 0 }} container>
              <HeaderLabelTitle
                title="Add Note (Max 150 Characters)"
                required
              />
            </Grid>
            <Grid sx={{ mb: 1 }} container>
              <TextField
                required
                id="notes"
                name="notes"
                placeholder="Notes"
                multiline={true}
                minRows={2}
                fullWidth
                variant="outlined"
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "space-between" }}>
          <CustomButtonCancel onClick={handleClose} />
          <CustomButtonSubmit label="Decline" color="error" />
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
